import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EDocumentType } from '../tools/ui/mutilple-file-upload-box/document-type';

@Injectable({
    providedIn: 'root'
})
export class PictureService {

    // interventionCode: string;
    DocumentType: EDocumentType;
    Description: string;
    private imageSubject = new BehaviorSubject('');

    get ImageEmitter() {
        return this.imageSubject;
    }

    getImageInfo() {
        return {
            // i: this.interventionCode,
            t: this.DocumentType,
            d: this.Description
        };
    }
    constructor() { }

    updateImage(image: string) {
        this.imageSubject.next(image);
    }

    updateImageInfo(type?: EDocumentType, description?: string) {
        // this.interventionCode = interventionCode;
        this.DocumentType = type;
        this.Description = description;
    }

    clearInfo() {
        // this.interventionCode = null;
        this.Description = null;
        this.DocumentType = null;
        this.updateImage(null);
    }
}
